enum LocalStorageKeys {
	activeTab = 'app_activeTab',
	appData = 'app_appData',
}

export const setActiveTab = (activeTab: string) => {
	localStorage.setItem(LocalStorageKeys.activeTab, activeTab);
};
export const getActiveTab = () => {
	const activeTab = localStorage.getItem(LocalStorageKeys.activeTab);
	// clearAuthId();
	return activeTab;
};
export const clearActiveTab = () => {
	localStorage.removeItem(LocalStorageKeys.activeTab);
};

export const setAppData = (appData: string) => {
	localStorage.setItem(LocalStorageKeys.appData, window.btoa(appData));
};
export const getAppData = () => {
	const data = localStorage.getItem(LocalStorageKeys.appData);
	const appData = data ? window.atob(String(data)) : '{}';
	// clearAuthId();
	return appData;
};
export const clearAppData = () => {
	localStorage.removeItem(LocalStorageKeys.appData);
};
